import { Component, Input } from '@angular/core';
import { StandardAssignmentPin, StandardAssignmentPins } from './standard-assignment-pins';

@Component({
  selector: 'app-standard-pin-checkbox',
  templateUrl: './standard-pin-checkbox.component.html',
  styleUrls: ['./standard-pin-checkbox.component.css']
})
export class StandardPinCheckboxComponent {
  @Input() row: StandardAssignmentPin;

  constructor(public pins: StandardAssignmentPins) {}

  toggle(event: Event): void {
    (event.target as HTMLInputElement).checked = this.row.checked;
    this.pins.toggle(this.row);
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/admin/standards-management/standard-pin-checkbox.component.ts